import script from "./AddArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddArticle.vue?vue&type=script&setup=true&lang=ts"

import "./AddArticle.vue?vue&type=style&index=0&id=8be30dc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8be30dc4"]])

export default __exports__